import { getQaSelector } from '../../../utils/common'
import { EntityPhaseList, EntityPhaseListLoading } from '../../Entity'
import Text from '../../Text'

import {
  getPhaseBarStatusText,
  getPhaseBarTooltipAdditionalText,
} from './RentalPortalPhaseBar.utils'

import * as styles from './RentalPortalPhaseBar.module.css'

function RentalPortalPhaseBar({ isLoading, items, qaName, terminalStatement }) {
  return isLoading || items?.length > 0 ? (
    <div
      {...getQaSelector({ value: qaName })}
      className={styles.RentalPortalPhaseBar}
    >
      {isLoading ? (
        <EntityPhaseListLoading />
      ) : (
        <EntityPhaseList
          getPhaseStatusText={getPhaseBarStatusText}
          getTooltipAdditionalText={getPhaseBarTooltipAdditionalText}
          items={items}
          showTooltip={false}
        />
      )}

      {terminalStatement ? (
        <Text isSecondary className={styles.terminalStatement}>
          {terminalStatement}
        </Text>
      ) : null}
    </div>
  ) : null
}

export default RentalPortalPhaseBar
